import React from 'react';
import { useTranslate } from 'react-admin';
import {
    BuyerLicenseType,
    BuyerListingLike,
    formatEuro,
    groupPriceKind,
    hasGroupPriceDeviation,
    totalListPriceCents,
    totalPriceCents,
} from '../../../pages/marketplaceVisibility';
import '../marketplace-design.css';

export interface PriceBlockProps {
    listing: BuyerListingLike & { currency: string };
    type: BuyerLicenseType;
    seats?: number;
    /** `large` für Detailseite und Checkout, `line` für Karten (Preiskachel je Lizenzart) */
    variant?: 'line' | 'large';
}

/**
 * Preisdarstellung für Käufer (Plan 3.4): Bei Gruppenherkunft mit abweichendem
 * Preis steht der Listenpreis durchgestrichen vor dem Gruppenpreis, dazu das
 * Label „Gruppenpreis: kostenlos / intern“. Preise sind netto (B2B, E4).
 */
const PriceBlock: React.FC<PriceBlockProps> = ({ listing, type, seats = 1, variant = 'line' }) => {
    const translate = useTranslate();
    const total = totalPriceCents(listing, type, seats) / 100;
    const list = totalListPriceCents(listing, type, seats) / 100;
    const deviates = hasGroupPriceDeviation(listing, type);
    const kind = groupPriceKind(listing, type);
    const effective = total === 0 ? translate('marketplaceBuyer.price.free') : formatEuro(total, listing.currency);

    return (
        <div data-testid={`price-${type}`} className={`mk-pr${variant === 'large' ? ' lg' : ''}`}>
            {deviates && (
                <span data-testid="price-struck" className="struck">
                    {formatEuro(list, listing.currency)}
                </span>
            )}
            <span data-testid="price-effective" className="eff">
                {effective}
            </span>
            {variant === 'line' && total !== 0 && <span className="unit">{translate('marketplaceBuyer.price.net')}</span>}
            {type === 'seat_copy' && total !== 0 && seats === 1 && (
                <span className="unit">{translate('marketplaceBuyer.price.perSeat')}</span>
            )}
            {kind && (
                <span data-testid="group-price-label" className="grp">
                    {translate(kind === 'free' ? 'marketplaceBuyer.price.groupFree' : 'marketplaceBuyer.price.groupInternal')}
                </span>
            )}
        </div>
    );
};

export default PriceBlock;
